class QuoteStore {
  constructor() {
    this.submitted = false;
    this.loading = false;
  }
}

export default new QuoteStore();



// WEBPACK FOOTER //
// ./src/js/QuoteStore.js